import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import PrivateRoutes from './components/PrivateRoutes';
import AdminLayout2 from './layouts/AdminLayout2';
import Layout from './layouts/Layout';
import ApproveInvoice from './pages/ApproveInvoice';
import DocumentDetails from './pages/DocumentDetails';
import InvoiceApprovers from './pages/InvoiceApprovers';
import Login from './pages/Login';
import MatchPO from './pages/MatchPO';
import PurchaseOrder from './pages/PurchaseOrder';
import RejectInvoice from './pages/RejectInvoice';
import Users from './pages/Users';
import Vendors from './pages/Vendors';

// Create a Query Client
const queryClient = new QueryClient();

export default function App() {
  const [isLightMode, setIsLightMode] = useState(true);

  const setTheme = () => {
    setIsLightMode(!isLightMode);
  };

  return (
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={{ colorScheme: isLightMode ? 'light' : 'dark' }}>
        <ModalsProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route
                path="/documents"
                element={<Layout setTheme={setTheme} />}
                exact
              />
              <Route path="/documents/:id" element={<DocumentDetails />} />
              <Route
                path="/admin"
                element={<AdminLayout2 setTheme={setTheme} />}>
                <Route index element={<Navigate to="/admin/users" replace />} />
                <Route path="users" element={<Users />} />
                <Route path="approvers" element={<InvoiceApprovers />} />
                <Route path="vendors" element={<Vendors />} />
              </Route>
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/approve-invoice" element={<ApproveInvoice />} />
            <Route path="/reject-invoice" element={<RejectInvoice />} />
            <Route path="/purchase-order" element={<PurchaseOrder />} />
            <Route path="/match-po" element={<MatchPO />} />
            <Route path="*" element={<Navigate to="/documents" replace />} />
          </Routes>
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  );
}
